
const RatingBar = ({ value = 0, max = 5, margin = "2", size = "4" }) => {
  const stars = [];
  for (let i = 1; i <= max; i++) {
    if (i <= value) {
      stars.push(
        <span className={`fs-${size} `} key={i} style={{ color: "#f5c518" }}>
          ★
        </span>
      );
    } else {
      stars.push(
        <span className={`fs-${size} `} key={i} style={{ color: "#ccc" }}>
          ☆
        </span>
      );
    }
  }
  return <div className={`m-${margin} `}>{stars}</div>;
};

export default RatingBar;
